/**
 * @Description: todo 分页工具 v1.0
 * @author wcd
 * @date 2020/5/1
 */
export default {

  /**
   * @Description: todo sign:标志；mode：规则
   * @author wcd
   * @date 2020/5/1
   */
  pagination(list, page, size, sign="id", mode='DESC') {
    try {
      let data = []//分页后的原始结果集
      let content = []//排序后的结果集
      let sortList = []//数列
      let total = list.length
      let statIndex = page > 1 ? (page - 1) * size : 0
      for (let i = 0; i < size && i < total - statIndex; i++) {
        let c = new Map()
        try {
          c = list[statIndex + i]
        } catch (e) {
          console.error('分页失败,参数有误', e)
          return []
        }
        data.push(c)
        sortList.push(parseInt(c[sign].toString().replace(/[^0-9]/ig, '')))
      }
      if (mode.toUpperCase() === 'DESC') {
        sortList.sort((a, b) => b - a)
      } else if (mode.toUpperCase() === 'ASC') {
        sortList.sort((a, b) => a - b)
      }
      sortList.forEach(e => {
        for (let i = 0; i < data.length; i++) {
          let s = parseInt(data[i][sign].toString().replace(/[^0-9]/ig, ''))
          if (e === s) {
            content.push(data[i])
            break
          }
        }
      })
      return content
    } catch (e) {
      console.error('分页失败,数据存在异常', e)
      return []
    }
  },

  /**
   * @Description: todo treeData(source, 'id', 'parentId', 'children')
   * @author wcd  数组转树形
   * @date 2020/5/1
   */
  treeData(source, id, pid, children) {
    let temp = JSON.parse(JSON.stringify(source));
    // 以id为键，当前对象为值，存入一个新的对象中
    let tempObj = {};
    for (let i in temp) {
      tempObj[temp[i][id]] = temp[i]
    }
    return temp.filter(father => {
      // 把当前节点的所有子节点找到
      let childArr = temp.filter(child => father[id] === child[pid]);
      childArr.length > 0 ? father[children] = childArr : '';
      // 只返回第一级数据；如果当前节点的fatherId不为空，但是在父节点不存在，也为一级数据
      return father[pid] === null || !tempObj[father[pid]];
    });
  },

  /**
   * @Description: todo arrayToTree(source,'children')
   * @author wcd  树形转数组
   * @date 2020/5/1
   */
  treeToArray(source, children) {
    let queen = [];
    let out = [];
    queen = queen.concat(source);
    while (queen.length) {
      let first = queen.shift();
      if (first[children]) {
        queen = queen.concat(first[children])
        delete first[children];
      }
      out.push(first);
    }
    return out;
  }


}




// WEBPACK FOOTER //
// ./src/utils/cdUtils/pageTool.js